import {useSelector, useDispatch} from 'react-redux';
import Selector from '../../../selectors/modals_action/welcome-package/index';
import GameSelector from '../../../selectors/modals_action/welcome-package/game';
import {WelcomePackage} from '../../../reducers/modals-action/actions';
import BlueButton from '../../components/blue-button';
import ModalsLib from '../../../lib/modals';

export default ({closeAction, nextStage}) => {    
    const {user, data, welcome_bonus} = useSelector(Selector),
          {game} = useSelector(GameSelector),
          dispatch = useDispatch();

    return (
        <div className="action-modal-body-container points">
            <div className="action-modal-body-top" style={{justifyContent: 'space-between'}}>
                <div className="title">Welcome Bonus</div>
                <div className="close" onClick={e => closeAction('close')}>
                    <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <path d="M6 18L18 6" stroke="white" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
                        <path d="M18 18L6 6" stroke="white" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
                    </svg>
                </div>
            </div>

            <div className="action-modal-body">
                <div className="description">
                    Confirm your phone number and email address to receive bonus!
                </div>

                <div className="step">{welcome_bonus.freeplay ? '1. Confirm details' : 'Confirm your details'}</div>
                <div className="points-list">
                    <div className={`point ${user.phone.status === 'confirmed' ? 'active' : ''}`} onClick={e => {
                        if(user.phone.status !== 'confirmed')
                            ModalsLib.open('phone_confirmation')
                    }}>
                        <svg width="22" height="22" viewBox="0 0 22 22" fill="none" xmlns="http://www.w3.org/2000/svg">
                            <path d="M20.72 17.08C20.72 17.44 20.64 17.81 20.47 18.17C20.3 18.53 20.08 18.87 19.79 19.19C19.3 19.73 18.76 20.12 18.15 20.37C17.55 20.62 16.9 20.75 16.2 20.75C15.18 20.75 14.09 20.51 12.94 20.02C11.79 19.53 10.64 18.87 9.5 18.04C8.35 17.2 7.26 16.27 6.22 15.24C5.19 14.2 4.26 13.11 3.43 11.97C2.61 10.83 1.95 9.69 1.47 8.56C0.99 7.42 0.75 6.33 0.75 5.29C0.75 4.61 0.87 3.96 1.11 3.36C1.35 2.75 1.73 2.19 2.26 1.69C2.9 1.06 3.6 0.75 4.34 0.75C4.62 0.75 4.9 0.81 5.15 0.93C5.41 1.05 5.64 1.23 5.82 1.49L8.14 4.76C8.32 5.01 8.45 5.24 8.54 5.46C8.63 5.67 8.68 5.88 8.68 6.07C8.68 6.31 8.61 6.55 8.47 6.78C8.34 7.01 8.15 7.25 7.91 7.49L7.15 8.28C7.04 8.39 6.99 8.52 6.99 8.68C6.99 8.76 7 8.83 7.02 8.91C7.05 8.99 7.08 9.05 7.1 9.11C7.28 9.44 7.59 9.87 8.03 10.39C8.48 10.91 8.96 11.44 9.48 11.97C10.02 12.5 10.54 12.99 11.07 13.44C11.59 13.88 12.02 14.18 12.36 14.36C12.41 14.38 12.47 14.41 12.54 14.44C12.62 14.47 12.7 14.48 12.79 14.48C12.96 14.48 13.09 14.42 13.2 14.31L13.96 13.56C14.21 13.31 14.45 13.12 14.68 13C14.91 12.86 15.14 12.79 15.39 12.79C15.58 12.79 15.78 12.83 16 12.92C16.22 13.01 16.45 13.14 16.7 13.31L20.01 15.66C20.27 15.84 20.45 16.05 20.56 16.3C20.66 16.55 20.72 16.8 20.72 17.08Z" stroke-width="1.5" stroke-miterlimit="10"/>
                        </svg>

                        <span>Confirm phone number</span>
                    </div>

                    <div className={`point ${user.email.status === 'confirmed' ? 'active' : ''}`} onClick={e => {
                        if(user.email.status !== 'confirmed')
                            ModalsLib.open('email_confirmation')
                    }}>
                        <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                            <path d="M17 20.5H7C4 20.5 2 19 2 15.5V8.5C2 5 4 3.5 7 3.5H17C20 3.5 22 5 22 8.5V15.5C22 19 20 20.5 17 20.5Z" stroke-width="1.5" stroke-miterlimit="10" stroke-linecap="round" stroke-linejoin="round"/>
                            <path d="M17 9L13.87 11.5C12.84 12.32 11.15 12.32 10.12 11.5L7 9" stroke-width="1.5" stroke-miterlimit="10" stroke-linecap="round" stroke-linejoin="round"/>
                        </svg>

                        <span>Confirm email address</span>
                    </div>
                </div>

                {welcome_bonus.freeplay ? (
                    <>
                        <div className="step" style={{marginTop: "15px"}}>2. Choose game</div>
                        <div className="game-selected" onClick={e => {
                            ModalsLib.open('changeGame', {
                                handler: e => dispatch(WelcomePackage.setGame(e)),
                                redirect: false,
                                welcome_bonus: true
                            });
                        }}>
                            {!game ? (
                                <>
                                    <div className="left">
                                        <div className="name">Select game</div>
                                    </div>
                                    <div className="button">
                                        <svg width="8" height="15" viewBox="0 0 8 15" fill="none" xmlns="http://www.w3.org/2000/svg">
                                            <path d="M0.75 13.95L6.18333 8.51667C6.825 7.875 6.825 6.825 6.18333 6.18333L0.75 0.75" stroke="#DFDFEC" stroke-width="1.5" stroke-miterlimit="10" stroke-linecap="round" stroke-linejoin="round"/>
                                        </svg>
                                    </div>
                                </>
                            ) : (
                                <>
                                    <div className="left">
                                        <div className="image">
                                            <img src={`${window.location.origin}/source/system/games/${game.slug}.png`}></img>
                                        </div>
                                        <div className="name">{game.name}</div>
                                    </div>
                                    <div className="button">
                                        <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
                                            <path d="M12.4082 4.23333C11.6832 4.01667 10.8832 3.875 9.9999 3.875C6.00824 3.875 2.7749 7.10833 2.7749 11.1C2.7749 15.1 6.00824 18.3333 9.9999 18.3333C13.9916 18.3333 17.2249 15.1 17.2249 11.1083C17.2249 9.625 16.7749 8.24167 16.0082 7.09167" stroke="#DFDFEC" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
                                            <path d="M13.4415 4.43333L11.0332 1.66666" stroke="#DFDFEC" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
                                            <path d="M13.4416 4.43333L10.6333 6.48333" stroke="#DFDFEC" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
                                        </svg>
                                    </div>
                                </>
                            )}
                        </div>
                    </>
                ) : <></>}

                <BlueButton active={data.button} disabled={((welcome_bonus.freeplay && !game) || user.phone.status !== 'confirmed' || user.email.status !== 'confirmed')} onClick={e => {
                    dispatch(WelcomePackage.activateBonus(data.game));
                    // nextStage();
                }}>
                    Redeem bonus
                </BlueButton>
            </div>
        </div>
    )
}